import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "collapse-container" }
const _hoisted_2 = { class: "collapse__stage" }
const _hoisted_3 = { class: "collapse-header" }
const _hoisted_4 = { class: "collapse__title" }
const _hoisted_5 = { class: "collapse__subtitle" }

import { useVModel } from '@vueuse/core';


export default /*@__PURE__*/_defineComponent({
  __name: 'CollapsibleSection',
  props: {
  index: {
    type: Number,
  },
  modelValue: {
    type: Number,
  },
},
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;
const value = useVModel(props, 'modelValue', emit);

function isActive() {
  return props.index === value.value;
}

function setActive() {
  value.value = props.index;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (setActive())),
      class: _normalizeClass([{ active: isActive() }, "collapsible"])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _renderSlot(_ctx.$slots, "icon", {}, () => [
          _createTextVNode(_toDisplayString(__props.index), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "title")
        ]),
        _createElementVNode("div", _hoisted_5, [
          _renderSlot(_ctx.$slots, "subtitle")
        ])
      ]),
      _cache[1] || (_cache[1] = _createElementVNode("svg", { class: "right-arrow" }, [
        _createElementVNode("use", {
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "xlink:href": "#arrow-right2"
        })
      ], -1))
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass([{ active: isActive() }, "collapse-content-container"])
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 2)
  ]))
}
}

})